import React, { useState, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Navbar, Nav, Container, NavDropdown, Image } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Header.css';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import OtpModal from '../../pages/OTP/OtpModal';
import axiosInstance from '../../axiosConfig/instance';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShoppingCart, faHeart } from '@fortawesome/free-solid-svg-icons';

import { clearUser } from '../../hooks/redux/userSlice';
import NotificationDropdown from './Notification';


const Header = () => {
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [otp, setOtp] = useState('');
  const [loading, setLoading] = useState(false); 
  
  const navigate = useNavigate();
  const location = useLocation();

  const dispatch = useDispatch();
  const userData = useSelector((state) => state.user.user);
  const isLoggedIn = Boolean(userData && userData.username);

  const handleLogout = () => {
    dispatch(clearUser());
    localStorage.clear();
    navigate('/');
  };

  const handleActiveLink = (path) => (location.pathname === path ? 'active' : '');

  const handleOtpSubmit = (enteredOtp) => {
    if (otp.some(item => enteredOtp.includes(item))) {
      localStorage.setItem('otpVerified', 'true');
      setOtp('');
      setShowOtpModal(false);
      navigate('/Shop/Shop');
    } else {
      alert('OTP غير صحيح، حاول مرة أخرى.');
    }
  };

  const generateAndSendOtp = async () => {
    const otpVerified = localStorage.getItem('otpVerified');
    const ShopID = localStorage.getItem('ShopID');

    if (otpVerified === 'true') {
      ShopID ? navigate('/OtpSuccess/OtpSuccess?url=../SystemHomePage/Home') : navigate('/Shop/Shop');
    } else {
      try {
        setShowOtpModal(true);
        setLoading(true); // بدء التحميل

        const response = await axiosInstance.post('OTP', {
          email: userData.email,
        });

        if (response.status === 200) {
          setOtp(response.data.data);
        } else {
          alert('فشل في إرسال OTP، حاول مرة أخرى.');
          setShowOtpModal(false);
        }
      } catch (error) {
        console.error('Error sending OTP:', error);
        alert('فشل في إرسال OTP، حاول مرة أخرى.');
      } finally {
        setLoading(false); // إيقاف التحميل
      }
    }
  };

  return (
    <>
    <Navbar
        className="App-header"
        collapseOnSelect
        expand="lg"
        fixed="top" 
        bg="dark"       
      >
      <Container>
        <Navbar.Brand as={Link} to="/">
          <Image src={'/Images/Logo/Logo2.png'} alt="شعار منصوري تكس" className="LogoImage" />
          
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mx-auto NavLinks">
            <Link to="/" className={`NavLink ${handleActiveLink('/')}`}>الصفحة الرئيسية</Link>
            {isLoggedIn ? (
              <>
                {(userData.usertype === "3" || userData.usertype === "4") && (
                  <Nav.Link onClick={generateAndSendOtp} className={`NavLink ${handleActiveLink('/OtpSuccess/OtpSuccess')}`}>
                    البرنامج
                  </Nav.Link>
                )}
                {userData.usertype === "2" && (
                  <>
                    <Link to="../MyAccount/MyAccount" className={`NavLink ${handleActiveLink('/MyAccount/MyAccount')}`}>حسابي</Link>
                    <Nav.Link href="/SendProducts">ارسال أصناف</Nav.Link>
                  </>
                )}
                {userData.usertype === "1" && (
                  <>
                    <Link to="../MyAccount/MyAccount" className={`NavLink ${handleActiveLink('/MyAccount/MyAccount')}`}>حسابي</Link>
                    <Link to="../Shoping/items" className={`NavLink ${handleActiveLink('/Shoping/items')}`}>التسوق</Link>
                  </>
                )}
              </>
            ) : (
              <>
                <Link to="../MyAccount/MyAccount" className={`NavLink ${handleActiveLink('/MyAccount/MyAccount')}`}>حسابي</Link>
                <Link to="../Shoping/items" className={`NavLink ${handleActiveLink('/Shoping/items')}`}>التسوق</Link>
              </>
            )}
            <Link to="../ContactUs/ContactUs" className={`NavLink ${handleActiveLink('/ContactUs/ContactUs')}`}>تواصل معنا</Link>
          </Nav>
          <div className="icon-links">
            <Link to="/fav" className="icon-link">
              <FontAwesomeIcon icon={faHeart} />
            </Link>
            <Link to="/cart" className="icon-link">
              <FontAwesomeIcon icon={faShoppingCart} />
            </Link>
            {isLoggedIn && <NotificationDropdown />}
          </div>
          {isLoggedIn ? (
            <NavDropdown
              title={
                <div className="d-inline-block">
                  {userData.profileImage &&
                  <img
                    src={userData.profileImage}
                    alt="صورة المستخدم"
                    style={{ width: '30px', height: '30px', borderRadius: '50%', marginRight: '10px' }}
                  />}
                  {userData.username}
                </div>
              }
              id="basic-nav-dropdown"
            >
              <NavDropdown.Item as={Link} to="/MyAccount/AccountDetails">بيانات حسابي</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item onClick={handleLogout}>تسجيل الخروج</NavDropdown.Item>
            </NavDropdown>
          ) : (
            <a href="../SignIn_Up/SignIn" className="btn shadow" role="button">
              تسجيل الدخول
            </a>
          )}
        </Navbar.Collapse>
      </Container>
      
    </Navbar>
    
  <OtpModal
    show={showOtpModal}
    handleClose={() => setShowOtpModal(false)}
    handleOtpSubmit={handleOtpSubmit}
    loading={loading}
  />
</>
  );
};

export default Header;